<div class="flex flex-col gap-4 relative">
  @for ( filterCombinationResponse of selectedFilterCombinations(); track $index
  ) {
  <!-- header -->
  <div class="flex flex-col gap-1">
    <h2 class="text-[#7f7f7f] text-xs font-medium">
      {{ filterCombinationResponse.name }} ({{ 'FILTER.SAVED_FILTERS' |
      translate }})
    </h2>
    <mat-divider />
  </div>

  <!-- visible wrapper for all filter chips -->
  <div
    [id]="
        'selected-filter-combinations-chips-wrapper-' +
        filterCombinationResponse.id
      "
    class="flex flex-wrap items-start content-start overflow-hidden relative"
    [ngStyle]="{
        gap: this.GAP_BETWEEN_CHIPS + 'px',
      }"
  >
    @let shownFilters =
    this.mapFilterCombinationFiltersToChips(filterCombinationResponse.appliedFilters);

    <!-- hint if nothing or all selected -->
    @if ( shownFilters.chips.length === 0) {
    <p class="italic font-thin text-xs">
      {{ 'UTILITY.NOTHING_SELECTED' | translate }}
    </p>
    } @for (filter of shownFilters.chips; track $index) {
    <mat-chip
      [ngStyle]="{
              'background-color': filter.backgroundColor,
            }"
      class="transition-all duration-300 ease-in-out"
      [disableRipple]="true"
      >{{ filter.label }}
    </mat-chip>
    }
    <!-- show hint how many filters are not shown -->
    @if (shownFilters.numOfLeftOverFilters > 0) {
    <mat-chip
      [ngStyle]="{
              'background-color': '#ffffff',
              color: '#202020',
              border: 'none',
            }"
      class="transition-all duration-300 ease-in-out"
      [disableRipple]="true"
      [disabled]="true"
      ><span class="italic font-semibold"
        >{{ shownFilters.numOfLeftOverFilters }} {{ 'UTILITY.MORE' | translate
        }} ...</span
      >
    </mat-chip>
    }
  </div>
  }
</div>
